<script>
import api from '@utils/api'
import SpecificationNew from './specification-new'
import SpecificationReturnsNew from './specification-returns-new'
import SpecificationReturns from './specification-returns'
import SpecificationMergeNew from './specification-merge-new'
import SpecificationMerge from './specification-merge'
import SpecificationDelete from './specification-delete'
import Specification from './specification'
import { getGoodsGroup } from '@utils/goods-group'

export default {
  metaInfo: {
    title: 'Specifications',
    meta: [{ name: 'description', content: 'Specifications' }],
  },
  name: 'Specifications',
  components: {
    SpecificationNew,
    SpecificationReturnsNew,
    SpecificationReturns,
    SpecificationDelete,
    Specification,
    SpecificationMergeNew,
    SpecificationMerge,
  },
  props: {
    specList: {
      type: Array,
      default: () => [],
    },
    currentDocument: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      headers: [
        { text: 'article', value: 'goods', sortable: false },
        { text: 'serial', value: 'serial', sortable: false },
        { text: 'unit', value: 'unit', sortable: false },
        { text: 'quantity', value: 'quantity', sortable: false },
        { text: 'actions', value: 'actions', sortable: false },
      ],
      isLoading: true,
      rowsPerPage: [10, 25, 50],
      content: [],
      pagination: {
        sortBy: 'article',
        descending: true,
      },
      totalElements: 0,
      newSpecification: false,
      editSpecification: false,
      currentSpecification: {},
    }
  },
  computed: {
    params() {
      return {
        size: this.pagination.rowsPerPage || null,
        page: this.pagination.page || null,
        sort_property: this.pagination.sortBy || null,
        sort_direction: this.pagination.descending || null,
      }
    },
    goods() {
      return this.$store.getters['data/getDictionary']('goods')
    },
    isFinalized() {
      return this.$route.params.document.status === 2
    },
    isReturns() {
      return this.$route.params.documentType === 'returns'
    },
    isMerge() {
      return this.$route.params.documentType === 'completeSet'
    },
    isCustom() {
      return (
        this.$route.params.documentType !== 'returns' &&
        this.$route.params.documentType !== 'completeSet'
      )
    },
  },
  watch: {
    params(val, oldVal) {
      // FIXME: Исправлено в версии 1.1 vuetify
      if (JSON.stringify(val) !== JSON.stringify(oldVal)) this.fetchData(val)
    },
  },
  methods: {
    fetchData(params) {
      this.isLoading = true
      const payload = {
        documentId: this.$route.params.documentId,
        params: params,
      }
      api.getSpecifications(payload).then(response => {
        this.content = response.content
        this.totalElements = response.totalElements
        this.isLoading = false
        this.$emit('update:spec', response.content)
      })
    },
    getValue(dictionaryName, value) {
      return this.$store.getters['data/getValueFromDictionary'](
        dictionaryName,
        value
      )
    },
    openSpecification(id) {
      this.currentSpecification = this.content.find(x => x.id === id)
      this.editSpecification = true
    },
    closeSpecEdit() {
      this.currentSpecification = null
      this.editSpecification = false
    },
    specWasUpdated() {
      this.currentSpecification = null
      this.editSpecification = false
      this.fetchData(this.params)
    },
    getGoodsGroup(goodsId) {
      return getGoodsGroup(this.goods, goodsId)
    },
  },
}
</script>

<template>
  <v-container fluid>
    <v-toolbar
      v-if="$route.params.document.status !== 2"
      flat
      color="grey lighten-5"
    >
      <v-spacer />
      <v-btn
        color="primary"
        dark
        @click="newSpecification = true"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="content"
      :pagination.sync="pagination"
      :total-items="totalElements"
      :rows-per-page-items="rowsPerPage"
      :rows-per-page-text="$t('table__rows_per_page_text')"
      :loading="isLoading"
      :class="$style.sdTable"
      sort-icon="expand_less"
      must-sort
    >
      <template
        slot="headerCell"
        slot-scope="props">
        {{ $t(`label__${props.header.text}`) }}
      </template>
      <v-progress-linear
        slot="progress"
        height="2"
        color="blue"
        background-color="#E0E0E0"
        indeterminate
      />
      <template
        slot="items"
        slot-scope="props"
      >
        <tr
          :class="$style.sdEditRow"
          @click="openSpecification(props.item.id)"
        >
          <td>{{ getValue('goods', props.item.goods) }}</td>
          <td>
            <router-link
              :to="
                { name: 'searchPlug', params: { serial: props.item.serial ,
                                                goodsGroup: getGoodsGroup(props.item.goods) }} "> {{ props.item.serial }}
            </router-link>
          </td>
          <td>{{ getValue('unit', props.item.unit) }}</td>
          <td>{{ props.item.quantity }}</td>
          <td class="text-xs-left">
            <specification-delete
              :disabled="isFinalized"
              :specification-id="props.item.id"
              @spec-deleted="fetchData(params)"
            />
          </td>
        </tr>
      </template>
      <template
        slot="pageText"
        slot-scope="{ pageStart, pageStop }"
      >
        {{ pageStart }}-{{ pageStop }} {{ $t('table__page_of') }} {{ totalElements }}
      </template>
    </v-data-table>
    <specification-returns-new
      v-if="isReturns"
      :new-specification="newSpecification"
      :current-document="currentDocument"
      @close-modal="newSpecification = false"
      @spec-added="fetchData(params)"
    />
    <specification-merge-new
      v-if="isMerge"
      :new-specification="newSpecification"
      :current-document="currentDocument"
      @close-modal="newSpecification = false"
      @spec-added="fetchData(params)"
    />
    <specification-new
      v-if="isCustom"
      :new-specification="newSpecification"
      :current-document="currentDocument"
      @close-modal="newSpecification = false"
      @spec-added="fetchData(params)"
    />
    <specification
      v-if="isCustom"
      :edit-specification="editSpecification"
      :specification="currentSpecification"
      :current-document="currentDocument"
      @close-modal="closeSpecEdit"
      @spec-updated="specWasUpdated"
    />
    <specification-merge
      v-if="isMerge"
      :edit-specification="editSpecification"
      :specification="currentSpecification"
      :current-document="currentDocument"
      @close-modal="closeSpecEdit"
      @spec-updated="specWasUpdated"
    />
    <specification-merge
      v-if="isReturns"
      :edit-specification="editSpecification"
      :specification="currentSpecification"
      :current-document="currentDocument"
      @close-modal="closeSpecEdit"
      @spec-updated="specWasUpdated"
    />
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.sdTable {
  border: 1px solid #dfdfdf;

  th {
    outline: none;
  }
}
.sdEditRow {
  cursor: pointer;
}
</style>
